import type { BreadcrumbItem } from '@/types/breadcrumb/breadcrumb.type';
import { t } from '../lang';

export interface RouteDetail {
    id?: string;
    routeKey: string;
}

export interface RouteManagerInterface {
    getRouteMap(): Record<string, any>;
    getBreadcrumb(items: RouteDetail[]): BreadcrumbItem[];
}

export interface RouteItem {
    label: string;
    path: (id?: any) => string;
    icon?: string;
    id: string;
    permissions: string[];
}

export class RouteManager implements RouteManagerInterface {
    public HOME = 'home';
    public TICKET = 'ticket';
    public TICKET_DETAIL = 'ticket-chi-tiet';
    public TICKET_CREATION = 'ticket-tao-moi';
    public TICKET_EDIT = 'ticket-chinh-sua';
    public TASK = 'task';
    public TASK_DETAIL = 'task-chi-tiet';
    public TASK_CREATION = 'task-tao-moi';
    public TASK_EDIT = 'task-chinh-sua';
    public ERROR_DETAIL_TASK_CHECK = 'su-co-sua-chua';
    public ERROR_DETAIL_TASK_CHECK_DETAIL = 'su-co-sua-chua-chi-tiet';
    public ERROR_DETAIL_TASK_CHECK_CREATION = 'su-co-sua-chua-tao-moi';
    public ERROR_DETAIL_TASK_CHECK_EDIT = 'su-co-sua-chua-chinh-sua';
    public DEVICE = 'thiet-bi';
    public DEVICE_CREATION = 'thiet-bi-tao-moi';
    public DEVICE_EDIT = 'thiet-bi-chinh-sua';
    public DEVICE_DETAIL = 'thiet-bi-chi-tiet';
    public COMPONENT_DETAIL = 'thanh-phan-chi-tiet';
    public ACCESSORY = 'phu-kien';
    public ACCESSORY_CREATION = 'phu-kien-tao-moi';
    public MATERIAL = 'nguyen-lieu';
    public STAFF = 'nhan-vien';
    public STAFF_DETAIL = 'nhan-vien-detail';
    public STAFF_CREATION = 'nhan-vien-creation';
    public STAFF_EDIT = 'nhan-vien-edit';
    public CUSTOMER = 'khach-hang';
    public CUSTOMER_DETAIL = 'khach-hang-detail';
    public CUSTOMER_CREATION = 'khach-hang-creation';
    public CUSTOMER_EDIT = 'khach-hang-edit';
    public DEVICE_TYPE = 'loai-thiet-bi';
    public DEVICE_TYPE_DETAIL = 'loai-thiet-bi-chi-tiet';
    public DEVICE_TYPE_CREATION = 'loai-thiet-bi-tao-moi';
    public DEVICE_TYPE_EDIT = 'loai-thiet-bi-chinh-sua';
    public DEVICE_GROUP = 'nhom-thiet-bi';
    public DEVICE_GROUP_DETAIL = 'nhom-thiet-bi-chi-tiet';
    public DEVICE_GROUP_CREATION = 'nhom-thiet-bi-tao-moi';
    public DEVICE_GROUP_EDIT = 'nhom-thiet-bi-chinh-sua';
    public DEVICE_SKU = 'sku-thiet-bi';
    public DEVICE_SKU_DETAIL = 'sku-thiet-bi-chi-tiet';
    public DEVICE_SKU_CREATION = 'sku-thiet-bi-tao-moi';
    public DEVICE_SKU_EDIT = 'sku-thiet-bi-chinh-sua';
    public DEVICE_MODEL = 'doi-thiet-bi';
    public DEVICE_MODEL_DETAIL = 'doi-thiet-bi-chi-tiet';
    public DEVICE_MODEL_CREATION = 'doi-thiet-bi-tao-moi';
    public DEVICE_MODEL_EDIT = 'doi-thiet-bi-chinh-sua';
    public COMPONENT_CATEGORY = 'danh-muc';
    public COMPONENT_CATEGORY_DETAIL = 'danh-muc-chi-tiet';
    public COMPONENT_CATEGORY_CREATION = 'danh-muc-tao-moi';
    public COMPONENT_CATEGORY_EDIT = 'danh-muc-chinh-sua';
    public COMPONENT_TYPE = 'loai-thanh-phan';
    public COMPONENT_TYPE_DETAIL = 'loai-thanh-phan-chi-tiet';
    public COMPONENT_TYPE_CREATION = 'loai-thanh-phan-tao-moi';
    public COMPONENT_TYPE_EDIT = 'loai-thanh-phan-chinh-sua';
    public COMPONENT_GROUP = 'nhom-thanh-phan';
    public COMPONENT_GROUP_DETAIL = 'nhom-thanh-phan-chi-tiet';
    public COMPONENT_GROUP_CREATION = 'nhom-thanh-phan-tao-moi';
    public COMPONENT_GROUP_EDIT = 'nhom-thanh-phan-chinh-sua';
    public COMPONENT_SKU = 'sku-thanh-phan';
    public COMPONENT_SKU_DETAIL = 'sku-thanh-phan-chi-tiet';
    public COMPONENT_SKU_CREATION = 'sku-thanh-phan-tao-moi';
    public COMPONENT_SKU_EDIT = 'sku-thanh-phan-chinh-sua';
    public TICKET_TYPE = 'loai-ticket';
    public TICKET_TYPE_DETAIL = 'loai-ticket-chi-tiet';
    public TICKET_TYPE_CREATION = 'loai-ticket-tao-moi';
    public TICKET_TYPE_EDIT = 'loai-ticket-chinh-sua';
    public TASK_TYPE = 'loai-task';
    public TASK_TYPE_DETAIL = 'loai-task-chi-tiet';
    public TASK_TYPE_CREATION = 'loai-task-tao-moi';
    public TASK_TYPE_EDIT = 'loai-task-chinh-sua';
    public USAGE_TYPE = 'loai-hinh-thuc-su-dung';
    public USAGE_TYPE_DETAIL = 'loai-hinh-thuc-su-dung-chi-tiet';
    public USAGE_TYPE_CREATION = 'loai-hinh-thuc-su-dung-tao-moi';
    public USAGE_TYPE_EDIT = 'loai-hinh-thuc-su-dung-chinh-sua';
    public ERROR_TYPE = 'loai-loi';
    public ERROR_TYPE_DETAIL = 'loai-loi-chi-tiet';
    public ERROR_TYPE_CREATION = 'loai-loi-tao-moi';
    public ERROR_TYPE_EDIT = 'loai-loi-chinh-sua';
    public ERROR = 'loi';
    public ERROR_DETAIL = 'chi-tiet-loi';
    public ERROR_CREATION = 'loi-tao-moi';
    public ERROR_EDIT = 'loi-chinh-sua';
    public VIOLATION = 'vi-pham';
    public VIOLATION_DETAIL = 'vi-pham-chi-tiet';
    public VIOLATION_CREATION = 'vi-pham-tao-moi';
    public VIOLATION_EDIT = 'vi-pham-chinh-sua';
    public VIOLATION_TYPE = 'loai-vi-pham';
    public VIOLATION_TYPE_DETAIL = 'loai-vi-pham-chi-tiet';
    public VIOLATION_TYPE_CREATION = 'loai-vi-pham-tao-moi';
    public VIOLATION_TYPE_EDIT = 'loai-vi-pham-chinh-sua';
    public ROLE = 'vai-tro';
    public TEMPLATE_CHECK = 'loai-phieu-bieu-mau';
    public TEMPLATE_CHECK_DETAIL = 'loai-phieu-bieu-mau-detail';
    public TEMPLATE_CHECK_CREATION = 'loai-phieu-bieu-mau-creation';
    public TEMPLATE_CHECK_EDIT = 'loai-phieu-bieu-mau-edit';
    public COMPONENT_RECOMMENDATION = 'de-xuat-linh-kien';
    public COMPONENT_RECOMMENDATION_DETAIL = 'chi-tiet-de-xuat-linh-kien';
    public COMPONENT_RECOMMENDATION_EDIT = 'de-xuat-linh-kien-chinh-sua';
    public VIOLATION_CUSTOMER = 'vi-pham-khach-hang';
    public VIOLATION_CUSTOMER_DETAIL = 'vi-pham-khach-hang-chi-tiet';
    public VIOLATION_CUSTOMER_CREATION = 'vi-pham-khach-hang-tao-moi';
    public VIOLATION_CUSTOMER_EDIT = 'vi-pham-khach-hang-chinh-sua';
    public COORDINATION = 'dieu-phoi';
    public BUSINESS_TRIP_FORM = 'phieu-cong-tac';
    public BUSINESS_TRIP_FORM_CREATION = 'phieu-cong-tac-create';
    public BUSINESS_TRIP_FORM_DETAIL = 'phieu-cong-tac-detail';
    public BUSINESS_TRIP_FORM_EDIT = 'phieu-cong-tac-edit';
    public QUALITY_MANAGEMENT = 'quan-ly-chat-luong';
    public QUALITY_MANAGEMENT_CREATION = 'quan-ly-chat-luong-tao-moi';
    public QUALITY_MANAGEMENT_DETAIL = 'quan-ly-chat-luong-chi-tiet';
    public QUALITY_MANAGEMENT_EDIT = 'quan-ly-chat-luong-chinh-sua';
    public DASHBOARD_TASK_REPEAT = 'thong-ke-task-lap-lai';
    public DASHBOARD_PERIODIC_OPERATION = 'van-hanh-dinh-ky';
    public DASHBOARD_TASK_OF_EACH_TECHNICIAN = 'cong-viec-cua-ktv';
    public DASHBOARD_COMPONENT_RECOMMENDATION_AND_REPLACEMENT =
        'de-xuat-va-thay-the-linh-kien';
    public DASHBOARD_MULTIDIMENSIONAL_SUMMARY = 'tong-hop-da-chieu';
    public REMINDER_SCHEDULE = 'lich-nhac-nho';
    public REMINDER_SCHEDULE_NOTIFICATION = 'thong-bao-lich-nhac-nho';
    public ATTRIBUTE_DEVICE_GROUP = 'nhom-thong-so-thiet-bi';
    public ATTRIBUTE_DEVICE_VALUE = 'thong-so-thiet-bi';
    public CUSTOMER_CONTACT = 'khach-hang-lien-he';
    public CUSTOMER_REVIEW = 'danh-gia-khach-hang';
    public PART_INSTALL = 'lap-dat-linh-kien';
    public PART_RECEIVE = 'linh-kien-nhan-ve';
    public PART_REPLACE = 'linh-kien-thay-the';
    public TECHNICIAN_LOG = 'technician-log';
    public DASHBOARD_GET_OPERATION_PERFORMANCE = 'van-hanh-dinh-ki';
    public DASHBOARD_GET_PART_SUGGESTION_REPLACE =
        'de-xuat-va-thay-the-linh-kien';
    public ADMIN = 'admin';
    public DASHBOARD_GET_MULTIDIMENSIONAL_REPORT = 'bao-cao-da-chieu';
    public CUSTOMER_ACCOUNT = 'tai-khoan-khach-hang';
    public MULTI_LANGUAGE_CONFIG = 'cau-hinh-da-ngon-ngu';
    public DYNAMIC_TICKET = 'dynamic-ticket';
    public DYNAMIC_TICKET_DETAIL = 'dynamic-ticket-chi-tiet';
    public DYNAMIC_TICKET_CREATION = 'dynamic-ticket-tao-moi';
    public DYNAMIC_TICKET_EDIT = 'dynamic-ticket-chinh-sua';
    public DYNAMIC_TASK = 'dynamic-task';
    public DYNAMIC_TASK_DETAIL = 'dynamic-task-chi-tiet';
    public DYNAMIC_TASK_CREATION = 'dynamic-task-tao-moi';
    public DYNAMIC_TASK_EDIT = 'dynamic-task-chinh-sua';
    public REPORT_PRODUCTIVITY_AND_MACHINE_CAPACITY =
        'nang-suat-va-cong-suat-may';
    public REPORT_COMPARE_PRODUCTIVITY = 'so-sanh-san-luong';
    public REPORT_MAINTENANCE_SCHEDULE = 'ke-hoach-bao-tri-theo-thoi-gian';
    public REPORT_REPLACEMENT_RATIO = 'ty-le-vat-tu-thay-the';
    public APP_CONFIG = 'cau-hinh-ung-dung';

    public getRouteMap(): Record<string, RouteItem> {
        return {
            [this.HOME]: {
                id: this.HOME,
                label: t('Trang chủ'),
                path: () => '/home',
                icon: 'home',
                permissions: ['*'],
            },
            [this.TICKET]: {
                id: this.TICKET,
                label: t('Danh sách'),
                path: () => '/ticket',
                permissions: ['Ticket.*'],
            },
            [this.TICKET_DETAIL]: {
                id: this.TICKET_DETAIL,
                label: t('Chi tiết Ticket'),
                path: (id?: string) => `/ticket/${id || ''}`,
                permissions: ['Ticket_Get_Detail'],
            },
            [this.TICKET_CREATION]: {
                id: this.TICKET_CREATION,
                label: t('Tạo Ticket'),
                path: () => '/ticket/tao-moi',
                permissions: ['Ticket_Create'],
            },
            [this.TICKET_EDIT]: {
                id: this.TICKET_EDIT,
                label: t('Chỉnh sửa Ticket'),
                path: (id: string) => `/ticket/${id || ''}/chinh-sua`,
                permissions: ['Ticket.*'],
            },
            [this.TASK]: {
                id: this.TASK,
                label: t('Danh sách'),
                path: () => '/task',
                permissions: ['TaskCheck_Get_List'],
            },
            [this.TASK_CREATION]: {
                id: this.TASK_CREATION,
                label: t('Tạo Task'),
                path: (params?: { ticketId?: string; customerId?: string }) => {
                    const query = params?.ticketId
                        ? `?ticketId=${params.ticketId}&customerId=${params.customerId}`
                        : '';

                    return `/task/tao-moi${query}`;
                },
                permissions: ['TaskCheck_Create'],
            },
            [this.TASK_DETAIL]: {
                id: this.TASK_DETAIL,
                label: t('Chi tiết Task'),
                path: (id?: string) => `/task/${id || ''}`,
                permissions: ['TaskCheck_Get_Detail'],
            },
            [this.TASK_EDIT]: {
                id: this.TASK_EDIT,
                label: t('Chỉnh sửa Task'),
                path: (id?: string) => `/task/${id || ''}/chinh-sua`,
                permissions: ['TaskCheck_Update'],
            },
            [this.ERROR_DETAIL_TASK_CHECK]: {
                id: this.ERROR_DETAIL_TASK_CHECK,
                label: t('Sự cố & Sửa chữa'),
                path: () => '/su-co-sua-chua',
                icon: 'incident',
                permissions: ['ErrorDetailTaskCheck_Get_List'],
            },
            [this.ERROR_DETAIL_TASK_CHECK_DETAIL]: {
                id: this.ERROR_DETAIL_TASK_CHECK_DETAIL,
                label: t('Chi tiết sự cố & sửa chữa'),
                path: (id?: string) => `/su-co-sua-chua/${id || ''}`,
                permissions: ['ErrorDetailTaskCheck_Get_Detail'],
            },
            [this.ERROR_DETAIL_TASK_CHECK_CREATION]: {
                id: this.ERROR_DETAIL_TASK_CHECK_CREATION,
                label: t('Tạo sự cố & sửa chữa'),
                path: () => '/su-co-sua-chua/tao-moi',
                permissions: ['ErrorDetailTaskCheck_Create'],
            },
            [this.ERROR_DETAIL_TASK_CHECK_EDIT]: {
                id: this.ERROR_DETAIL_TASK_CHECK_EDIT,
                label: t('Chỉnh sửa sự cố & sửa chữa'),
                path: (id?: string) => `/su-co-sua-chua/${id || ''}/chinh-sua`,
                permissions: ['ErrorDetailTaskCheck_Update'],
            },
            [this.DEVICE]: {
                id: this.DEVICE,
                label: t('Thiết bị'),
                path: () => '/thiet-bi',
                icon: 'device',
                permissions: ['Device_Get_List'],
            },
            [this.DEVICE_CREATION]: {
                id: this.DEVICE_CREATION,
                label: t('Tạo thiết bị'),
                path: () => '/thiet-bi/tao-moi',
                icon: 'device',
                permissions: ['Device_Create'],
            },
            [this.DEVICE_EDIT]: {
                id: this.DEVICE_EDIT,
                label: t('Chỉnh sửa thiết bị'),
                path: (id?: string) => `/thiet-bi/${id || ''}/chinh-sua`,
                icon: 'device',
                permissions: ['Device_Update'],
            },
            [this.DEVICE_DETAIL]: {
                id: this.DEVICE_DETAIL,
                label: t('Chi tiết thiết bị'),
                path: (id?: string) => `/thiet-bi/${id || ''}`,
                icon: 'device',
                permissions: ['Device_Get_Detail'],
            },
            [this.STAFF]: {
                id: this.STAFF,
                label: t('Nhân viên'),
                path: () => '/nhan-vien',
                icon: 'staff',
                permissions: ['Admin_Get_User_List'],
            },
            [this.STAFF_DETAIL]: {
                id: this.STAFF_DETAIL,
                label: t('Chi tiết nhân viên'),
                path: (id?: string) => `/nhan-vien/${id || ''}`,
                permissions: ['Admin_Get_User_Detail'],
            },
            [this.STAFF_CREATION]: {
                id: this.STAFF_CREATION,
                label: t('Tạo thông tin nhân viên'),
                path: () => '/nhan-vien/create',
                permissions: ['Admin_Create_User'],
            },
            [this.STAFF_EDIT]: {
                id: this.STAFF_EDIT,
                label: t('Chỉnh sửa thông tin nhân viên'),
                path: (id?: string) => `/nhan-vien/${id || ''}/chinh-sua`,
                permissions: ['Admin_Reset_Password'],
            },
            [this.CUSTOMER]: {
                id: this.CUSTOMER,
                label: t('Khách hàng'),
                path: () => '/khach-hang',
                icon: 'customer',
                permissions: ['Customer_Get_List'],
            },

            [this.CUSTOMER_DETAIL]: {
                id: this.CUSTOMER_DETAIL,
                label: t('Chi tiết khách hàng'),
                path: (id?: string) => `/khach-hang/${id || ''}`,
                permissions: ['Customer_Get_Detail'],
            },
            [this.CUSTOMER_CREATION]: {
                id: this.CUSTOMER_CREATION,
                label: t('Tạo thông tin khách hàng'),
                path: () => '/khach-hang/create',
                permissions: ['Customer_Create'],
            },
            [this.CUSTOMER_EDIT]: {
                id: this.CUSTOMER_EDIT,
                label: t('Chỉnh sửa thông tin khách hàng'),
                path: () => '/khach-hang/edit',
                permissions: ['Customer_Update'],
            },
            [this.DEVICE_TYPE]: {
                id: this.DEVICE_TYPE,
                label: t('Loại thiết bị'),
                path: () => '/cau-hinh/thiet-bi/loai',
                icon: '',
                permissions: ['DeviceType_Get_List'],
            },
            [this.DEVICE_TYPE_DETAIL]: {
                id: this.DEVICE_TYPE_DETAIL,
                label: t('Chi tiết loại thiết bị'),
                path: (id?: string) => `/cau-hinh/thiet-bi/loai/${id || ''}`,
                icon: '',
                permissions: ['DeviceType_Get_Detail'],
            },
            [this.DEVICE_TYPE_CREATION]: {
                id: this.DEVICE_TYPE_CREATION,
                label: t('Tạo mới'),
                path: () => '/cau-hinh/thiet-bi/loai/tao-moi',
                icon: '',
                permissions: ['DeviceType_Create'],
            },
            [this.DEVICE_TYPE_EDIT]: {
                id: this.DEVICE_TYPE_EDIT,
                label: t('Chỉnh sửa'),
                path: (id?: string) =>
                    `/cau-hinh/thiet-bi/loai/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['DeviceType_Update'],
            },
            [this.DEVICE_GROUP]: {
                id: this.DEVICE_GROUP,
                label: t('Nhóm thiết bị'),
                path: () => '/cau-hinh/thiet-bi/nhom',
                icon: '',
                permissions: ['DeviceGroup_Get_List'],
            },
            [this.DEVICE_GROUP_DETAIL]: {
                id: this.DEVICE_GROUP_DETAIL,
                label: t('Chi tiết nhóm thiết bị'),
                path: (id?: string) => `/cau-hinh/thiet-bi/nhom/${id || ''}`,
                icon: '',
                permissions: ['DeviceGroup_Get_Detail'],
            },
            [this.DEVICE_GROUP_CREATION]: {
                id: this.DEVICE_GROUP_CREATION,
                label: t('Tạo mới nhóm thiết bị'),
                path: () => '/cau-hinh/thiet-bi/nhom/tao-moi',
                icon: '',
                permissions: ['DeviceGroup_Create'],
            },
            [this.DEVICE_GROUP_EDIT]: {
                id: this.DEVICE_GROUP_EDIT,
                label: t('Chỉnh sửa'),
                path: (id?: string) =>
                    `/cau-hinh/thiet-bi/nhom/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['DeviceGroup_Update'],
            },
            [this.DEVICE_SKU]: {
                id: this.DEVICE_SKU,
                label: t('SKU thiết bị'),
                path: () => '/cau-hinh/thiet-bi/sku',
                icon: '',
                permissions: ['DeviceSKU_Get_List'],
            },
            [this.DEVICE_SKU_DETAIL]: {
                id: this.DEVICE_SKU_DETAIL,
                label: t('Chi tiết SKU thiết bị'),
                path: (id?: string) => `/cau-hinh/thiet-bi/sku/${id || ''}`,
                icon: '',
                permissions: ['DeviceSKU_Get_Detail'],
            },
            [this.DEVICE_SKU_CREATION]: {
                id: this.DEVICE_SKU_CREATION,
                label: t('Tạo mới'),
                path: () => '/cau-hinh/thiet-bi/sku/tao-moi',
                icon: '',
                permissions: ['DeviceSKU_Create'],
            },
            [this.DEVICE_SKU_EDIT]: {
                id: this.DEVICE_SKU_EDIT,
                label: t('Chỉnh sửa'),
                path: (id?: string) =>
                    `/cau-hinh/thiet-bi/sku/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['DeviceSKU_Update'],
            },
            [this.DEVICE_MODEL]: {
                id: this.DEVICE_MODEL,
                label: t('Đời thiết bị'),
                path: () => '/cau-hinh/thiet-bi/doi',
                icon: '',
                permissions: ['DeviceModel_Get_List'],
            },
            [this.DEVICE_MODEL_DETAIL]: {
                id: this.DEVICE_MODEL_DETAIL,
                label: t('Chi tiết đời thiết bị'),
                path: (id?: string) => `/cau-hinh/thiet-bi/doi/${id || ''}`,
                icon: '',
                permissions: ['DeviceModel_Get_Detail'],
            },
            [this.DEVICE_MODEL_CREATION]: {
                id: this.DEVICE_MODEL_CREATION,
                label: t('Tạo mới'),
                path: () => '/cau-hinh/thiet-bi/doi/tao-moi',
                icon: '',
                permissions: ['DeviceModel_Create'],
            },
            [this.DEVICE_MODEL_EDIT]: {
                id: this.DEVICE_MODEL_EDIT,
                label: t('Chỉnh sửa'),
                path: (id?: string) =>
                    `/cau-hinh/thiet-bi/doi/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['DeviceModel_Update'],
            },
            [this.COMPONENT_CATEGORY]: {
                id: this.COMPONENT_CATEGORY,
                label: t('Danh mục thành phần'),
                path: () => '/cau-hinh/thanh-phan/danh-muc',
                icon: '',
                permissions: ['PartCategory_Get_List'],
            },
            [this.COMPONENT_CATEGORY_DETAIL]: {
                id: this.COMPONENT_CATEGORY_DETAIL,
                label: t('Chi tiết danh mục thành phần'),
                path: (id?: string) =>
                    `/cau-hinh/thanh-phan/danh-muc/${id || ''}`,
                icon: '',
                permissions: ['PartCategory_Get_Detail'],
            },
            [this.COMPONENT_CATEGORY_CREATION]: {
                id: this.COMPONENT_CATEGORY_CREATION,
                label: t('Tạo mới danh mục thành phần'),
                path: () => '/cau-hinh/thanh-phan/danh-muc/tao-moi',
                icon: '',
                permissions: ['PartCategory_Create'],
            },
            [this.COMPONENT_CATEGORY_EDIT]: {
                id: this.COMPONENT_CATEGORY_EDIT,
                label: t('Chỉnh sửa danh mục thành phần'),
                path: (id?: string) =>
                    `/cau-hinh/thanh-phan/danh-muc/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['PartCategory_Update'],
            },
            [this.COMPONENT_TYPE]: {
                id: this.COMPONENT_TYPE,
                label: t('Loại thành phần'),
                path: () => '/cau-hinh/thanh-phan/loai',
                icon: '',
                permissions: ['PartType_Get_List'],
            },
            [this.COMPONENT_TYPE_DETAIL]: {
                id: this.COMPONENT_TYPE_DETAIL,
                label: t('Chi tiết loại thành phần'),
                path: (id?: string) => `/cau-hinh/thanh-phan/loai/${id || ''}`,
                icon: '',
                permissions: ['PartType_Get_Detail'],
            },
            [this.COMPONENT_TYPE_CREATION]: {
                id: this.COMPONENT_TYPE_CREATION,
                label: t('Tạo mới loại thành phần'),
                path: () => '/cau-hinh/thanh-phan/loai/tao-moi',
                icon: '',
                permissions: ['PartType_Create'],
            },
            [this.COMPONENT_TYPE_EDIT]: {
                id: this.COMPONENT_TYPE_EDIT,
                label: t('Chỉnh sửa loại thành phần'),
                path: (id?: string) =>
                    `/cau-hinh/thanh-phan/loai/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['PartType_Update'],
            },
            [this.COMPONENT_GROUP]: {
                id: this.COMPONENT_GROUP,
                label: t('Nhóm thành phần'),
                path: () => '/cau-hinh/thanh-phan/nhom',
                icon: '',
                permissions: ['PartGroup_Get_List'],
            },
            [this.COMPONENT_GROUP_DETAIL]: {
                id: this.COMPONENT_GROUP_DETAIL,
                label: t('Chi tiết nhóm thành phần'),
                path: (id?: string) => `/cau-hinh/thanh-phan/nhom/${id || ''}`,
                icon: '',
                permissions: ['PartGroup_Get_Detail'],
            },
            [this.COMPONENT_GROUP_CREATION]: {
                id: this.COMPONENT_GROUP_CREATION,
                label: t('Tạo mới nhóm thành phần'),
                path: () => '/cau-hinh/thanh-phan/nhom/tao-moi',
                icon: '',
                permissions: ['PartGroup_Create'],
            },
            [this.COMPONENT_GROUP_EDIT]: {
                id: this.COMPONENT_GROUP_EDIT,
                label: t('Chỉnh sửa nhóm thành phần'),
                path: (id?: string) =>
                    `/cau-hinh/thanh-phan/nhom/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['PartGroup_Update'],
            },
            [this.COMPONENT_SKU]: {
                id: this.COMPONENT_SKU,
                label: t('SKU thành phần'),
                path: () => '/cau-hinh/thanh-phan/sku',
                icon: '',
                permissions: ['PartSKU_Get_List'],
            },
            [this.COMPONENT_SKU_DETAIL]: {
                id: this.COMPONENT_SKU_DETAIL,
                label: t('Chi tiết SKU thành phần'),
                path: (id?: string) => `/cau-hinh/thanh-phan/sku/${id || ''}`,
                icon: '',
                permissions: ['PartSKU_Get_Detail'],
            },
            [this.COMPONENT_SKU_CREATION]: {
                id: this.COMPONENT_SKU_CREATION,
                label: t('Tạo mới SKU thành phần'),
                path: () => '/cau-hinh/thanh-phan/sku/tao-moi',
                icon: '',
                permissions: ['PartSKU_Create'],
            },
            [this.COMPONENT_SKU_EDIT]: {
                id: this.COMPONENT_SKU_EDIT,
                label: t('Chỉnh sửa SKU thành phần'),
                path: (id?: string) =>
                    `/cau-hinh/thanh-phan/sku/${id || ''}/chinh-sua`,
                icon: '',
                permissions: ['PartSKU_Update'],
            },
            [this.TICKET_TYPE]: {
                id: this.TICKET_TYPE,
                label: t('Loại Ticket'),
                path: () => '/cau-hinh/tac-vu/loai-ticket',
                icon: '',
                permissions: ['TicketType_Get_List'],
            },
            [this.TICKET_TYPE_DETAIL]: {
                id: this.TICKET_TYPE_DETAIL,
                label: t('Chi tiết loại Ticket'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-ticket/${id || ''}`,
                permissions: ['TicketType_Get_Detail'],
            },
            [this.TICKET_TYPE_CREATION]: {
                id: this.TICKET_TYPE_CREATION,
                label: t('Tạo loại Ticket'),
                path: () => '/cau-hinh/tac-vu/loai-ticket/tao-moi',
                permissions: ['TicketType_Create'],
            },
            [this.TICKET_TYPE_EDIT]: {
                id: this.TICKET_TYPE_EDIT,
                label: t('Chỉnh sửa loại Ticket'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-ticket/${id || ''}/chinh-sua`,
                permissions: ['TicketType_Update'],
            },
            [this.TASK_TYPE]: {
                id: this.TASK_TYPE,
                label: t('Loại Task'),
                path: () => '/cau-hinh/tac-vu/loai-task',
                icon: '',
                permissions: ['TaskCheckType_Get_List'],
            },
            [this.TASK_TYPE_DETAIL]: {
                id: this.TASK_TYPE_DETAIL,
                label: t('Chi tiết loại Task'),
                path: (id?: string) => `/cau-hinh/tac-vu/loai-task/${id || ''}`,
                permissions: ['TaskCheckType_Get_Detail'],
            },
            [this.TASK_TYPE_CREATION]: {
                id: this.TASK_TYPE_CREATION,
                label: t('Tạo loại Task'),
                path: () => '/cau-hinh/tac-vu/loai-task/tao-moi',
                permissions: ['TaskCheckType_Create'],
            },
            [this.TASK_TYPE_EDIT]: {
                id: this.TASK_TYPE_EDIT,
                label: t('Chỉnh sửa loại Task'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-task/${id || ''}/chinh-sua`,
                permissions: ['TaskCheckType_Update'],
            },
            [this.TEMPLATE_CHECK]: {
                id: this.TEMPLATE_CHECK,
                label: t('Loại phiếu biểu mẫu'),
                path: () => '/cau-hinh/tac-vu/bieu-mau',
                permissions: ['TemplateCheck_Get_List'],
            },
            [this.TEMPLATE_CHECK_DETAIL]: {
                id: this.TEMPLATE_CHECK_DETAIL,
                label: t('Chi tiết biểu mẫu'),
                path: (id?: string) => `/cau-hinh/tac-vu/bieu-mau/${id || ''}`,
                permissions: ['TemplateCheck_Get_Detail'],
            },
            [this.TEMPLATE_CHECK_CREATION]: {
                id: this.TEMPLATE_CHECK_CREATION,
                label: t('Tạo biểu mẫu'),
                path: () => '/cau-hinh/tac-vu/bieu-mau/create',
                permissions: ['TemplateCheck_Create'],
            },
            [this.TEMPLATE_CHECK_EDIT]: {
                id: this.TEMPLATE_CHECK_EDIT,
                label: t('Chỉnh sửa biểu mẫu'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/bieu-mau/${id || ''}/edit`,
                permissions: ['TemplateCheck_Update'],
            },
            [this.USAGE_TYPE]: {
                id: this.USAGE_TYPE,
                label: t('Loại hình thức sử dụng'),
                path: () => '/cau-hinh/tac-vu/loai-hinh-thuc-su-dung',
                icon: '',
                permissions: ['UsageType_Get_List'],
            },
            [this.USAGE_TYPE_DETAIL]: {
                id: this.USAGE_TYPE_DETAIL,
                label: t('Chi tiết loại hình thức sử dụng'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-hinh-thuc-su-dung/${id || ''}`,
                permissions: ['UsageType_Get_Detail'],
            },
            [this.USAGE_TYPE_CREATION]: {
                id: this.USAGE_TYPE_CREATION,
                label: t('Tạo loại hình thức sử dụng'),
                path: () => '/cau-hinh/tac-vu/loai-hinh-thuc-su-dung/tao-moi',
                permissions: ['UsageType_Create'],
            },
            [this.USAGE_TYPE_EDIT]: {
                id: this.USAGE_TYPE_EDIT,
                label: t('Chỉnh sửa loại hình thức sử dụng'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-hinh-thuc-su-dung/${id || ''}/chinh-sua`,
                permissions: ['UsageType_Update'],
            },

            // change Permissions when api done
            [this.ERROR_TYPE]: {
                id: this.ERROR_TYPE,
                label: t('Loại sự cố'),
                path: () => '/cau-hinh/tac-vu/loai-loi',
                icon: '',
                permissions: ['ErrorType_Get_List'],
            },
            [this.ERROR_TYPE_DETAIL]: {
                id: this.ERROR_TYPE_DETAIL,
                label: t('Chi tiết loại sự cố'),
                path: (id?: string) => `/cau-hinh/tac-vu/loai-loi/${id || ''}`,
                permissions: ['ErrorType_Get_Detail'],
            },
            [this.ERROR_TYPE_CREATION]: {
                id: this.ERROR_TYPE_CREATION,
                label: t('Tạo loại sự cố'),
                path: () => '/cau-hinh/tac-vu/loai-loi/tao-moi',
                permissions: ['ErrorType_Create'],
            },
            [this.ERROR_TYPE_EDIT]: {
                id: this.ERROR_TYPE_EDIT,
                label: t('Chỉnh sửa loại sự cố'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-loi/${id || ''}/chinh-sua`,
                permissions: ['ErrorType_Update'],
            },

            [this.ERROR]: {
                id: this.ERROR,
                label: t('Sự cố'),
                path: () => '/cau-hinh/tac-vu/chi-tiet-loi',
                icon: '',
                permissions: ['ErrorDetail_Get_List'],
            },
            [this.ERROR_DETAIL]: {
                id: this.ERROR_DETAIL,
                label: t('Chi tiết thông tin lỗi'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/chi-tiet-loi/${id || ''}`,
                permissions: ['ErrorDetail_Get_Detail'],
            },
            [this.ERROR_CREATION]: {
                id: this.ERROR_CREATION,
                label: t('Tạo thông tin lỗi'),
                path: () => '/cau-hinh/tac-vu/chi-tiet-loi/tao-moi',
                permissions: ['ErrorDetail_Create'],
            },
            [this.ERROR_EDIT]: {
                id: this.ERROR_EDIT,
                label: t('Chỉnh sửa thông tin lỗi'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/chi-tiet-loi/${id || ''}/chinh-sua`,
                permissions: ['ErrorDetail_Update'],
            },

            // hange Permissions when api done
            [this.VIOLATION_TYPE]: {
                id: this.VIOLATION_TYPE,
                label: t('Loại hành vi'),
                path: () => '/cau-hinh/tac-vu/loai-vi-pham',
                icon: '',
                permissions: ['ViolationType_Get_List'],
            },
            [this.VIOLATION_TYPE_DETAIL]: {
                id: this.VIOLATION_TYPE_DETAIL,
                label: t('Chi tiết loại hành vi'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-vi-pham/${id || ''}`,
                permissions: ['ViolationType_Get_Detail'],
            },
            [this.VIOLATION_TYPE_CREATION]: {
                id: this.VIOLATION_TYPE_CREATION,
                label: t('Tạo loại hành vi'),
                path: () => '/cau-hinh/tac-vu/loai-vi-pham/tao-moi',
                permissions: ['ViolationType_Create'],
            },
            [this.VIOLATION_TYPE_EDIT]: {
                id: this.VIOLATION_TYPE_EDIT,
                label: t('Chỉnh sửa loại hành vi'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/loai-vi-pham/${id || ''}/chinh-sua`,
                permissions: ['ViolationType_Update'],
            },
            [this.VIOLATION]: {
                id: this.VIOLATION,
                label: t('Hành vi'),
                path: () => '/cau-hinh/tac-vu/chi-tiet-vi-pham',
                icon: '',
                permissions: ['ViolationDetail_Get_List'],
            },
            [this.VIOLATION_DETAIL]: {
                id: this.VIOLATION_DETAIL,
                label: t('Chi tiết mã hành vi'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/chi-tiet-vi-pham/${id || ''}`,
                permissions: ['ViolationDetail_Get_Detail'],
            },
            [this.VIOLATION_CREATION]: {
                id: this.VIOLATION_CREATION,
                label: t('Tạo mã hành vi'),
                path: () => '/cau-hinh/tac-vu/chi-tiet-vi-pham/tao-moi',
                permissions: ['ViolationDetail_Create'],
            },
            [this.VIOLATION_EDIT]: {
                id: this.VIOLATION_EDIT,
                label: t('Chỉnh sửa mã hành vi'),
                path: (id?: string) =>
                    `/cau-hinh/tac-vu/chi-tiet-vi-pham/${id || ''}/chinh-sua`,
                permissions: ['ViolationDetail_Update'],
            },

            [this.ROLE]: {
                id: this.ROLE,
                label: t('Vai trò'),
                path: () => '/vai-tro',
                icon: 'rolePermission',
                permissions: ['AppRole_Get_List'],
            },

            [this.COMPONENT_RECOMMENDATION]: {
                id: this.COMPONENT_RECOMMENDATION,
                label: t('Đề xuất linh kiện'),
                path: () => '/de-xuat-linh-kien',
                icon: 'componentRecommendation',
                permissions: ['PartRequisition_Get_List'],
            },
            [this.COMPONENT_RECOMMENDATION_EDIT]: {
                id: this.COMPONENT_RECOMMENDATION_EDIT,
                label: t('Cập nhật phiếu đề xuất'),
                path: (id?: string) =>
                    `/de-xuat-linh-kien/${id || ''}/chinh-sua`,
                icon: 'rolePermission',
                permissions: ['PartRequisition_Update'],
            },
            [this.COMPONENT_RECOMMENDATION_DETAIL]: {
                id: this.COMPONENT_RECOMMENDATION_DETAIL,
                label: t('Chi tiết phiếu đề xuất'),
                path: (id?: string) => `/de-xuat-linh-kien/${id || ''}`,
                icon: '',
                permissions: ['PartRequisition_Get_Detail'],
            },
            [this.VIOLATION_CUSTOMER]: {
                id: this.VIOLATION_CUSTOMER,
                label: t('Sai phạm khách hàng'),
                path: () => '/sai-pham-khach-hang',
                icon: 'violation',
                permissions: ['ViolationDetailTaskCheck_Get_List'],
            },
            [this.VIOLATION_CUSTOMER_CREATION]: {
                id: this.VIOLATION_CUSTOMER_CREATION,
                label: t('Tạo mới sai phạm khách hàng'),
                path: () => '/sai-pham-khach-hang/tao-moi',
                icon: 'rolePermission',
                permissions: ['ViolationDetailTaskCheck_Create'],
            },
            [this.VIOLATION_CUSTOMER_DETAIL]: {
                id: this.VIOLATION_CUSTOMER_DETAIL,
                label: t('Chi tiết sai phạm khách hàng'),
                path: (id?: string) => `/sai-pham-khach-hang/${id || ''}`,
                icon: 'rolePermission',
                permissions: ['ViolationDetailTaskCheck_Get_Detail'],
            },
            [this.VIOLATION_CUSTOMER_EDIT]: {
                id: this.VIOLATION_CUSTOMER_EDIT,
                label: t('Chỉnh sửa Sai phạm khách hàng'),
                path: (id?: string) =>
                    `/sai-pham-khach-hang/${id || ''}/chinh-sua`,
                icon: 'rolePermission',
                permissions: ['ViolationDetailTaskCheck_Update'],
            },
            [this.COORDINATION]: {
                id: this.COORDINATION,
                label: t('Điều phối'),
                path: () => '/dieu-phoi-cong-viec',
                icon: 'rolePermission',
                permissions: ['StaffCoordination_Get_List'],
            },
            [this.BUSINESS_TRIP_FORM]: {
                id: this.BUSINESS_TRIP_FORM,
                label: t('Phiếu công tác'),
                path: () => '/phieu-cong-tac',
                icon: 'coordination',
                permissions: ['BusinessTripForm_Get_List'],
            },
            [this.BUSINESS_TRIP_FORM_DETAIL]: {
                id: this.BUSINESS_TRIP_FORM_DETAIL,
                label: t('Chi tiết phiếu công tác'),
                path: (id?: string) => `/phieu-cong-tac/${id || ''}`,
                icon: 'clockBill',
                permissions: ['BusinessTripForm_Get_Detail'],
            },
            [this.BUSINESS_TRIP_FORM_CREATION]: {
                id: this.BUSINESS_TRIP_FORM_CREATION,
                label: t('Tạo phiếu công tác'),
                path: () => `/phieu-cong-tac/tao-moi`,
                icon: 'clockBill',
                permissions: ['*'],
            },
            [this.BUSINESS_TRIP_FORM_EDIT]: {
                id: this.BUSINESS_TRIP_FORM_EDIT,
                label: t('Chỉnh sửa phiếu công tác'),
                path: (id?: string) => `/phieu-cong-tac/${id || ''}/chinh-sua`,
                icon: 'clockBill',
                permissions: ['BusinessTripForm_Update'],
            },
            [this.QUALITY_MANAGEMENT]: {
                id: this.QUALITY_MANAGEMENT,
                label: t('Checklist'),
                path: () => '/quan-ly-chat-luong',
                icon: 'clockBill',
                permissions: ['QualityManagement_Get_List'],
            },
            [this.QUALITY_MANAGEMENT_DETAIL]: {
                id: this.QUALITY_MANAGEMENT_DETAIL,
                label: t('Chi tiết Checklist'),
                path: (id?: string) => `/quan-ly-chat-luong/${id || ''}`,
                icon: 'clockBill',
                permissions: ['QualityManagement_Get_Detail'],
            },
            [this.QUALITY_MANAGEMENT_CREATION]: {
                id: this.QUALITY_MANAGEMENT_CREATION,
                label: t('Tạo mới Checklist'),
                path: () => `/quan-ly-chat-luong/tao-moi`,
                icon: 'clockBill',
                permissions: ['QualityManagement_Create'],
            },
            [this.QUALITY_MANAGEMENT_EDIT]: {
                id: this.QUALITY_MANAGEMENT_EDIT,
                label: t('Chỉnh sửa Checklist'),
                path: (id?: string) =>
                    `/quan-ly-chat-luong/${id || ''}/chinh-sua`,
                icon: 'clockBill',
                permissions: ['QualityManagement_Update'],
            },
            [this.DASHBOARD_TASK_REPEAT]: {
                id: this.DASHBOARD_TASK_REPEAT,
                label: t('Lỗi lặp lại từng KTV'),
                path: () => '/bao-cao/loi-lap-lai-ktv',
                permissions: ['Dashboard_Get_Task_Repeat'],
            },
            [this.DASHBOARD_PERIODIC_OPERATION]: {
                id: this.DASHBOARD_PERIODIC_OPERATION,
                label: t('Vận hành định kì'),
                path: () => '/bao-cao/van-hanh-dinh-ky',
                permissions: ['Dashboard_Get_Operation_Performance'],
            },
            [this.DASHBOARD_TASK_OF_EACH_TECHNICIAN]: {
                id: this.DASHBOARD_TASK_OF_EACH_TECHNICIAN,
                label: t('Công việc của từng KTV'),
                path: () => '/bao-cao/cong-viec-cua-tung-ktv',
                permissions: ['Dashboard_Get_Task_Processing'],
            },
            [this.DASHBOARD_COMPONENT_RECOMMENDATION_AND_REPLACEMENT]: {
                id: this.DASHBOARD_COMPONENT_RECOMMENDATION_AND_REPLACEMENT,
                label: t('Đề xuất & thay thế linh kiện'),
                path: () => '/bao-cao/de-xuat-&-thay-the-linh-kien',
                permissions: ['Dashboard_Get_Part_Suggestion_Replace'],
            },
            [this.DASHBOARD_MULTIDIMENSIONAL_SUMMARY]: {
                id: this.DASHBOARD_MULTIDIMENSIONAL_SUMMARY,
                label: t('Tổng hợp đa chiều'),
                path: () => '/bao-cao/tong-hop-da-chieu',
                permissions: ['Dashboard_Get_Multidimensional_Report'],
            },
            [this.REMINDER_SCHEDULE]: {
                id: this.REMINDER_SCHEDULE,
                label: t('Lịch nhắc nhở'),
                path: () => 'lich-nhac-nho',
                permissions: ['ReminderSchedule_Get_List'],
            },
            [this.CUSTOMER_CONTACT]: {
                id: this.CUSTOMER_CONTACT,
                label: t('Khách hàng liên hệ'),
                path: () => '/khach-hang-lien-he',
                permissions: ['CustomerContact_Get_List'],
            },
            [this.ADMIN]: {
                id: this.ADMIN,
                label: t('admin'),
                path: () => '/admin',
                permissions: ['Admin_Get_User_List'],
            },
            [this.MULTI_LANGUAGE_CONFIG]: {
                id: this.MULTI_LANGUAGE_CONFIG,
                label: t('Cấu hình ngôn ngữ'),
                path: () => '/cau-hinh/da-ngon-ngu',
                icon: 'translate',
                permissions: ['Translation_Get_List'],
            },
            [this.DYNAMIC_TICKET]: {
                id: this.DYNAMIC_TICKET,
                label: t('Cấu hình tự động'),
                path: () => '/dynamic-ticket',
                permissions: ['TicketTemplate_Get_List'],
            },
            [this.DYNAMIC_TICKET_DETAIL]: {
                id: this.DYNAMIC_TICKET_DETAIL,
                label: t('Chi tiết Ticket động'),
                path: (id?: string) => `/dynamic-ticket/${id || ''}`,
                permissions: ['TicketTemplate_Get_Detail'],
            },
            [this.DYNAMIC_TICKET_CREATION]: {
                id: this.DYNAMIC_TICKET_CREATION,
                label: t('Tạo Ticket động'),
                path: () => '/dynamic-ticket/tao-moi',
                permissions: ['TicketTemplate_Create'],
            },
            [this.DYNAMIC_TICKET_EDIT]: {
                id: this.DYNAMIC_TICKET_EDIT,
                label: t('Chỉnh sửa Ticket động'),
                path: (id: string) => `/dynamic-ticket/${id || ''}/chinh-sua`,
                permissions: ['TicketTemplate_Update'],
            },
            [this.DYNAMIC_TASK]: {
                id: this.DYNAMIC_TASK,
                label: t('Cấu hình tự động'),
                path: () => '/dynamic-task',
                permissions: ['TaskTemplateDevice_Get_List'],
            },
            [this.DYNAMIC_TASK_DETAIL]: {
                id: this.DYNAMIC_TASK_DETAIL,
                label: t('Chi tiết Task động'),
                path: (id?: string) => `/dynamic-task/${id || ''}`,
                permissions: ['TaskTemplateDevice_Get_Detail'],
            },
            [this.DYNAMIC_TASK_CREATION]: {
                id: this.DYNAMIC_TASK_CREATION,
                label: t('Tạo Task động'),
                path: () => '/dynamic-task/tao-moi',
                permissions: ['TaskTemplateDevice_Create'],
            },
            [this.DYNAMIC_TASK_EDIT]: {
                id: this.DYNAMIC_TASK_EDIT,
                label: t('Chỉnh sửa Task động'),
                path: (id: string) => `/dynamic-task/${id || ''}/chinh-sua`,
                permissions: ['TaskTemplateDevice_Update'],
            },
            [this.REPORT_PRODUCTIVITY_AND_MACHINE_CAPACITY]: {
                id: this.REPORT_PRODUCTIVITY_AND_MACHINE_CAPACITY,
                label: t('Năng suất & Công suất máy'),
                path: () => '/bao-cao/nang-suat-va-cong-suat-may',
                permissions: ['Reports_Performance'],
            },
            [this.REPORT_COMPARE_PRODUCTIVITY]: {
                id: this.REPORT_COMPARE_PRODUCTIVITY,
                label: t('So sánh sản lượng'),
                path: () => '/bao-cao/so-sanh-san-luong',
                permissions: ['Reports_Production_Comparison'],
            },
            [this.REPORT_MAINTENANCE_SCHEDULE]: {
                id: this.REPORT_MAINTENANCE_SCHEDULE,
                label: t('Kế hoạch bảo trì theo thời gian'),
                path: () => '/bao-cao/ke-hoach-bao-tri-theo-thoi-gian',
                permissions: ['Reports_Device_Maintenance_Schedule'],
            },
            [this.REPORT_REPLACEMENT_RATIO]: {
                id: this.REPORT_REPLACEMENT_RATIO,
                label: t('Tỷ lệ vật tư thay thế'),
                path: () => '/bao-cao/ty-le-vat-tu-thay-the',
                permissions: ['Reports_Spare_Part_Replacement_Rate'],
            },
            [this.APP_CONFIG]: {
                id: this.APP_CONFIG,
                label: t('Cấu hình'),
                path: () => '/app-config',
                permissions: ['Config_Get_List'],
            },
        };
    }

    public getBreadcrumb(items: RouteDetail[]): BreadcrumbItem[] {
        const routeMap = this.getRouteMap();

        return items.map(item => {
            const route = routeMap[item.routeKey];

            if (!route) {
                console.warn(`Không tìm thấy routeKey=${item.routeKey}`);

                return { name: 'Unknown', href: '/' };
            }

            let href = route.path;

            if (typeof route.path === 'function') {
                if (item.id) {
                    href = route.path(item.id);
                } else {
                    href = route.path('');
                }
            }

            return {
                name: route.label,
                href,
            };
        });
    }
}
